import { getUsersDetailsReportsWithDate } from '../apis';
import dayjs from './dayjs';
import { FormatSystemDateTime } from './helpers';

export const normalizeUsersDetailsReportUser = (user: any) => ({
	...user,
	id: user.id ?? user.userID,
	accountId: user.accountId ?? user.accountID,
	currencyPolicyId: user.currencyPolicyId ?? user.currenciesPoliciesID,
	demo: user.demo ?? user.isDemo,
	genericPolicyId: user.genericPolicyId ?? user.genericPoliciesID,
	userName: user.userName ?? user.username,
});

const addUserIds = (ids: Set<string>, value: unknown) => {
	const values = Array.isArray(value) ? value : [value];
	values.forEach((id) => {
		const normalizedId = String(id ?? '').trim();
		if (normalizedId) {
			ids.add(normalizedId);
		}
	});
};

export const getUsersDetailsReportUserIds = (userData: any) => {
	const ids = new Set<string>();
	addUserIds(ids, userData?.clientTreeUserIdNode);
	addUserIds(ids, userData?.dealerTreeUserIdNode);
	addUserIds(ids, userData?.id ?? userData?.userID);
	return Array.from(ids).join(',');
};

export const getUsersDetailsReportUsers = async (
	arkbaseurl: string | undefined,
	userData: any,
	userIdsOverride?: number | string,
) => {
	const defaultStartDate = dayjs()
		.set('year', 1000)
		.set('hour', 0)
		.set('minute', 0)
		.set('second', 0)
		.toDate();
	const defaultEndDate = dayjs()
		.set('year', 3000)
		.set('hour', 23)
		.set('minute', 59)
		.set('second', 59)
		.toDate();

	const start = FormatSystemDateTime(
		defaultStartDate,
		userData?.gmtOffset,
		userData?.serverGmtOffset,
		'ToServer',
	);
	const end = FormatSystemDateTime(
		defaultEndDate,
		userData?.gmtOffset,
		userData?.serverGmtOffset,
		'ToServer',
	);
	const userIds = userIdsOverride !== undefined
		? String(userIdsOverride)
		: getUsersDetailsReportUserIds(userData);

	const result = await getUsersDetailsReportsWithDate(
		arkbaseurl,
		userIds,
		start,
		end,
		true,
		userData?.token,
	);

	if (result?.success && Array.isArray(result.data)) {
		return {
			...result,
			data: result.data.map(normalizeUsersDetailsReportUser),
		};
	}

	return result;
};
